import type { FloatingReaction } from '../lib/engine.ts';

/** Emoji that drift up over the video when either side reacts. */
export function ReactionLayer({ reactions }: { reactions: FloatingReaction[] }) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {reactions.map((reaction) => (
        <span
          key={reaction.id}
          className="absolute bottom-32 text-5xl animate-float-up drop-shadow-[0_4px_16px_rgba(0,0,0,0.6)]"
          style={{
            left: `${reaction.x}%`,
            ['--drift' as string]: `${(reaction.from === 'me' ? 1 : -1) * (20 + Math.random() * 50)}px`,
          }}
        >
          {reaction.emoji}
        </span>
      ))}
    </div>
  );
}

export const REACTION_EMOJI = ['😂', '❤️', '🔥', '👋', '😮', '👏'];
